/**
 * Live Signal Extraction — deterministic heuristic detection
 * 
 * Scans user input for recognizable decision-relevant patterns.
 * No LLM calls. Pure keyword/pattern matching.
 * Triggers only after 120+ chars to avoid noise.
 */

export interface LiveSignal {
  key: string;
  label: string;
}

const SIGNAL_RULES: Array<{ key: string; label: string; pattern: RegExp }> = [
  {
    key: 'options',
    label: 'Mögliche Richtungen erkannt',
    pattern: /\b(oder|zwischen|entweder|versus|vs\.?|option|alternativ|variante|richtung|einerseits|andererseits|stattdessen|anstatt|auf der einen|auf der anderen)\b/i,
  },
  {
    key: 'conflict',
    label: 'Zielkonflikt',
    pattern: /\b(aber|jedoch|problem|schwierig|widerspruch|dilemma|konflikt|spannung|trade-?off|abwäg|einerseits.*andererseits|gleichzeitig|sowohl.*als auch)\b/i,
  },
  {
    key: 'time_pressure',
    label: 'Zeitdruck',
    pattern: /\b(zeit|deadline|frist|dringend|schnell|bald|sofort|monate?|wochen?|runway|zeitfenster|bis ende|bis zum|müssen wir jetzt)\b/i,
  },
  {
    key: 'risk',
    label: 'Risiken',
    pattern: /\b(risiko|gefahr|verlust|scheitern|angst|worst.?case|schlimmsten?falls|bedenken|unsicher|existenz|insolvenz|kannibali)\b/i,
  },
  {
    key: 'stakeholders',
    label: 'Beteiligte',
    pattern: /\b(team|mitarbeiter|gründer|investor|kunde|partner|board|vorstand|gesellschafter|stakeholder|abteilung)\b/i,
  },
  {
    key: 'metric',
    label: 'Messbare Ziele',
    pattern: /\b(umsatz|revenue|marge|conversion|churn|kosten|budget|roi|kpi|kennzahl|wachstum|growth|prozent|euro|€|\d+\s*%)\b/i,
  },
];

const MIN_LENGTH = 120;

export function detectLiveSignals(text: string): LiveSignal[] {
  const trimmed = text.trim();
  if (trimmed.length < MIN_LENGTH) return [];

  const signals: LiveSignal[] = [];

  for (const rule of SIGNAL_RULES) {
    if (rule.pattern.test(trimmed)) {
      signals.push({ key: rule.key, label: rule.label });
    }
  }

  return signals;
}
